"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const buildCallableGetDeviceInfo = (args) => async ({ entryVars: { propName }, callbacks, executeProcesses, functionId, processor, }) => {
    let value;
    switch (propName) {
        case 'buildId':
            value = args.getBuildId;
            break;
        case 'batteryLevel':
            value = args.getBatteryLevel;
            break;
        case 'brand':
            value = args.getBrand;
            break;
        case 'buildNumber':
            value = args.getBuildNumber;
            break;
        case 'carrier':
            value = args.getCarrier;
            break;
        case 'deviceId':
            value = args.getDeviceId;
            break;
        case 'uniqueId':
            value = args.getUniqueId;
            break;
        default:
            if (processor.root.isInDevelopment) {
                processor.root.alert('VALUE ERROR.', 'THE "propName" VALUE ENTERED IS INCORRECT.');
            }
            return;
    }
    const functionValue = await value.function();
    if (value.status() === false) {
        if (processor.root.isInDevelopment && !(callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError)) {
            processor.root.alert('FUNCTION NOT AVAILABLE.', `${functionValue}`);
        }
        executeProcesses(functionId, callbacks.onError, functionValue);
    }
    else {
        executeProcesses(functionId, callbacks.onComputed, functionValue);
    }
};
exports.default = buildCallableGetDeviceInfo;
